/* Ability Warehouse — Tools page: savings calculator (does the membership pay for itself?) and the measuring guide calculators */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format((c || 0) / 100); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); };

  /* ---------- Savings calculator ---------- */
  $$('[data-ts]').forEach(function (ts) {
    var X = window.CWIndex;
    var pct = parseFloat(ts.dataset.pct) || 10;
    var monthly = parseFloat(ts.dataset.monthly) || 27;
    var annual = parseFloat(ts.dataset.annual) || 197;
    var threshold = parseFloat(ts.dataset.threshold) || 500;
    var joinUrl = ts.dataset.join || '/pages/membership';
    var state = { basket: [], months: 3, repeat: 'once' };
    var items = null;
    var q = $('[data-ts-q]', ts), sug = $('[data-ts-suggest]', ts), basketEl = $('[data-ts-basket]', ts), emptyEl = $('[data-ts-empty]', ts);
    var KEY = 'aw_savings';
    try { var saved = JSON.parse(sessionStorage.getItem(KEY)); if (saved && saved.basket) state = saved; } catch (e) {}

    function load() { if (!X) return Promise.reject(); if (items) return Promise.resolve(items); return X.load('/collections/all').then(function (l) { items = l; return l; }); }
    function save() { try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }

    function renderSeg(key) {
      $$('[data-ts-opts="' + key + '"] button', ts).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.value) === String(state[key]) ? 'true' : 'false'); });
    }
    function renderBasket() {
      basketEl.innerHTML = state.basket.map(function (it, i) {
        return '<li class="ts__row" data-i="' + i + '">' + (it.im ? '<img src="' + X.img(it.im, 120) + '" alt="" loading="lazy">' : '<span class="ph"></span>') +
          '<span class="ts__row-t"><b>' + esc(it.t) + '</b><small>' + money(it.p) + ' guest · members <b>' + money(it.m) + '</b></small></span>' +
          '<span class="ts__qty"><button type="button" data-step="-1" aria-label="One fewer">−</button><input type="number" min="1" value="' + it.q + '" inputmode="numeric" aria-label="Quantity" data-qty><button type="button" data-step="1" aria-label="One more">+</button></span>' +
          '<button type="button" class="ts__rm" data-rm aria-label="Remove ' + esc(it.t) + '">×</button></li>';
      }).join('');
      emptyEl.hidden = state.basket.length > 0;
      var c = $('[data-ts-count]', ts);
      if (c) c.textContent = state.basket.length ? state.basket.length + (state.basket.length === 1 ? ' product' : ' products') : '';
    }
    function totals() {
      var guest = 0, member = 0;
      state.basket.forEach(function (it) { guest += it.p * it.q; member += it.m * it.q; });
      var times = state.repeat === 'monthly' ? state.months : 1;
      guest *= times; member *= times;
      var orderGuest = guest / times;
      var needsAnnual = orderGuest / 100 > threshold;
      var feeMonthly = monthly * 100 * state.months;
      var feeAnnual = annual * 100 * (state.months > 12 ? Math.ceil(state.months / 12) : 1);
      var plan = needsAnnual ? 'annual' : (feeMonthly <= feeAnnual ? 'monthly' : 'annual');
      var fee = plan === 'annual' ? feeAnnual : feeMonthly;
      return { guest: guest, member: member, save: guest - member, fee: fee, plan: plan, needsAnnual: needsAnnual, all: member + fee, net: guest - member - fee };
    }
    function renderTotals() {
      var t = totals();
      $('[data-ts-guest]', ts).textContent = money(t.guest);
      $('[data-ts-memberall]', ts).textContent = money(t.all);
      $('[data-ts-save]', ts).textContent = money(t.save);
      $('[data-ts-plan]', ts).textContent = state.basket.length ? (t.plan === 'annual' ? 'annual plan $' + annual + '/yr' : 'monthly plan $' + monthly + ' × ' + state.months) : '';
      var v = $('[data-ts-verdict]', ts);
      v.className = 'ts__verdict';
      if (!state.basket.length) { v.textContent = 'Add a product to see whether membership pays for itself.'; return; }
      var period = state.months + (state.months === 1 ? ' month' : ' months');
      if (t.net > 0) {
        v.classList.add('is-yes');
        v.innerHTML = '<b>Yes — membership pays for itself.</b> Over ' + period + ' you\'d be <b>' + money(t.net) + '</b> ahead after the fee' + (t.needsAnnual ? ' (an order over $' + threshold + ' needs the annual plan)' : '') + '. <a href="' + joinUrl + '">Join →</a>';
      } else if (t.net === 0) {
        v.innerHTML = 'It\'s a wash over ' + period + ' — the saving matches the fee. Add one more product and you\'re ahead.';
      } else {
        v.classList.add('is-no');
        v.innerHTML = '<b>Not yet.</b> Over ' + period + ' the fee is ' + money(-t.net) + ' more than you\'d save. ' +
          (state.repeat === 'once' ? 'Buying this basket every month, or ' : '') + 'adding about <b>' + money(Math.ceil((-t.net) / (pct / 100))) + '</b> of products would tip it.';
      }
    }
    function render() { renderSeg('months'); renderSeg('repeat'); renderBasket(); renderTotals(); save(); }

    var timer;
    if (q) {
      q.addEventListener('input', function () {
        clearTimeout(timer);
        var v = q.value.trim();
        if (v.length < 2) { sug.hidden = true; return; }
        timer = setTimeout(function () {
          sug.hidden = false; sug.innerHTML = '<p class="msg">Searching…</p>';
          load().then(function (list) {
            var res = X.search(list, v).slice(0, 8);
            sug.innerHTML = res.length ? res.map(function (it) {
              return '<button type="button" data-add="' + it.i + '">' + (it.im ? '<img src="' + X.img(it.im, 120) + '" alt="">' : '<span class="ph"></span>') + '<span class="t">' + esc(it.t) + '</span><span class="p">' + money(it.p) + '</span></button>';
            }).join('') : '<p class="msg">No products match “' + esc(v) + '”.</p>';
          }).catch(function () { sug.innerHTML = '<p class="msg">Couldn\'t load the product list.</p>'; });
        }, 120);
      });
      document.addEventListener('click', function (e) { if (!sug.contains(e.target) && e.target !== q) sug.hidden = true; });
    }
    ts.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || !ts.contains(b)) return;
      if (b.hasAttribute('data-add')) {
        var it = (items || []).filter(function (x) { return String(x.i) === b.dataset.add; })[0];
        if (!it) return;
        var ex = state.basket.filter(function (x) { return x.i === it.i; })[0];
        if (ex) ex.q += 1; else state.basket.push({ i: it.i, t: it.t, im: it.im, p: it.p, m: it.m, q: 1 });
        sug.hidden = true; q.value = ''; render(); return;
      }
      var seg = b.closest('[data-ts-opts]');
      if (seg) { var k = seg.getAttribute('data-ts-opts'); state[k] = k === 'months' ? parseInt(b.dataset.value, 10) : b.dataset.value; render(); return; }
      var row = b.closest('.ts__row');
      if (row) {
        var i = parseInt(row.dataset.i, 10);
        if (b.hasAttribute('data-rm')) state.basket.splice(i, 1);
        else if (b.dataset.step) state.basket[i].q = Math.max(1, state.basket[i].q + parseInt(b.dataset.step, 10));
        render(); return;
      }
      if (b.hasAttribute('data-ts-example')) {
        load().then(function (list) {
          var picks = [];
          ['shower chair', 'toilet frame', 'rollator'].forEach(function (w) { var r = X.search(list, w).filter(function (x) { return x.a; })[0]; if (r && picks.indexOf(r) < 0) picks.push(r); });
          if (!picks.length) picks = list.slice(0, 3);
          state.basket = picks.map(function (it) { return { i: it.i, t: it.t, im: it.im, p: it.p, m: it.m, q: 1 }; });
          state.months = 3; render();
        }).catch(function () {});
      }
    });
    ts.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-qty]');
      if (!inp) return;
      var i = parseInt(inp.closest('.ts__row').dataset.i, 10);
      state.basket[i].q = Math.max(1, parseInt(inp.value, 10) || 1);
      render();
    });
    render();
  });

  /* ---------- Measuring guide: three tiny calculators ---------- */
  $$('[data-ts-calc]').forEach(function (el) {
    var kind = el.dataset.tsCalc;
    var a = $('[data-a]', el), b = $('[data-b]', el), out = $('[data-out]', el);
    var num = function (i) { var v = i ? parseFloat(i.value) : NaN; return isFinite(v) && v > 0 ? v : 0; };
    function set(text, cls) { out.className = 'ts__out' + (cls ? ' is-' + cls : ''); out.innerHTML = text; }
    function update() {
      var A = num(a), B = num(b);
      if (kind === 'toilet') {
        if (!A || !B) return set('Enter both measurements.');
        var gap = B - A;
        if (gap <= 1) return set('Seat height ' + A + ' cm vs lower leg ' + B + ' cm — the toilet is already at a good height. A <b>toilet surround frame</b> gives something to push up from without raising the seat.', 'ok');
        var raise = gap <= 6 ? 5 : gap <= 12 ? 10 : 15;
        return set('The seat sits <b>' + gap.toFixed(1) + ' cm</b> below the lower-leg length. Look for a <b>' + raise + ' cm raised toilet seat</b>, or an over-toilet frame with the seat set to about <b>' + Math.round(B) + ' cm</b>.' + (gap > 15 ? ' That is a big gap — a frame with an adjustable seat is the safer choice.' : ''), 'ok');
      }
      if (kind === 'seat') {
        if (!B) return set('Enter the lower-leg length.');
        return set('Aim for a seat height of <b>' + Math.round(B) + '–' + Math.round(B + 3) + ' cm</b>. Most shower chairs and stools adjust in 2.5 cm steps — pick one whose range covers that. Higher makes standing easier; lower is steadier when seated.', 'ok');
      }
      if (kind === 'door') {
        if (!A) return set('Enter the doorway width — add the product width to check a specific item.');
        if (!B) return set('Doorway <b>' + A + ' cm</b>. As a rule: standard walkers and rollators are 55–65 cm wide, most wheelchairs 60–70 cm, bariatric models 70–80 cm. Allow <b>3–5 cm</b> clearance each side for turning.');
        var clear = A - B;
        if (clear < 0) return set('<b>It won\'t fit:</b> the product is ' + (-clear).toFixed(1) + ' cm wider than the doorway. Look for a narrower model or a folding one.', 'warn');
        if (clear < 4) return set('Tight: only <b>' + clear.toFixed(1) + ' cm</b> spare in total. It will pass straight on but turning through it will be hard. A narrower model is safer.', 'warn');
        return set('<b>It fits</b> with ' + clear.toFixed(1) + ' cm to spare. Check the hallway it turns from is at least as wide.', 'ok');
      }
    }
    $$('input', el).forEach(function (i) { i.addEventListener('input', update); });
    update();
  });
})();
